module.exports = __webpack_public_path__ + "img/steg.4a67653a.png";